//import { createSlider } from './slider-component-pd';

import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

class TabsMenu extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelectorAll('.tab-menu-item-button').forEach(tab => tab.addEventListener('click', this.selectTab.bind(this)));

        let ready = (callback) => {
            if (document.readyState != "loading") callback();
            else document.addEventListener("DOMContentLoaded", callback);
        }
        
        ready(() => { 
            setTimeout(() => {
                this.handleUrlHash()
            }, 200);
        });
        window.addEventListener('hashchange', () => this.handleUrlHash())
    }

    handleUrlHash() {
        const hash = window.location.hash.substring(1);
        if (hash) {
            this.activateTab(hash);
        }
    }

    activateTab(tabId) {
        const tabButton = this.querySelector(`[data-tab="${tabId}"]`);
        if (tabButton) {
            this.selectTab({ target: tabButton });
        }
    }

    selectTab(event) {
        const selected = event.target.dataset.tab;
        const target = document.querySelector('tabs-content');
        this.querySelectorAll('.tab-menu-item-button').forEach(item => item.classList.remove('tab-menu-item-menu--active'));
        event.target.classList.add('tab-menu-item-menu--active');

        const customEvent = new CustomEvent('changetabmembership', {
            detail: { selected }
        });

        target.dispatchEvent(customEvent); // Dispatch the event directly
    }
}

class TabsContent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.onInitSlider();
        this.onInitSecondSlider();
        this.addEventListener('changetabmembership', this.setActive.bind(this));
    }
    
    scrollToTab(toOpen) {
        if (toOpen) {
            setTimeout(() => {
                const header = document.querySelector('sticky-header');
                const headerHeight = header ? header.offsetHeight + 20 : 20;
                const elementPosition = toOpen.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerHeight;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }, 100);
        }
    }

    setActive(event) {
        const selectedTab = event.detail.selected;        
        this.querySelectorAll('.tabs-content').forEach(content => content.setAttribute('data-show', false));
        const selector = `#${selectedTab}`;
        const toOpen = this.querySelector(selector);

        setTimeout(() => {
            toOpen.setAttribute('data-show', true);
            this.scrollToTab(toOpen);
        }, 300);
    }

    onInitSlider(){
        const slider = this.querySelectorAll('.tabs-content-slider--main');
        slider.forEach(item => {
            setTimeout(() => {
                new Swiper(item, {
                    modules: [Navigation, Pagination],
                    navigation: {
                        nextEl: `.${item.getAttribute('data-arrow-right')}`,
                        prevEl: `.${item.getAttribute('data-arrow-left')}`
                    },
                    pagination: {
                        el: `.${item.getAttribute('data-pagination')}`,
                        clickable: true
                    },
                    slidesPerView: 1
                });
            }, 500);
        });
    }

    onInitSecondSlider(){
        const slider = this.querySelectorAll('.tabs-content-slider--second');
        slider.forEach(item => {
            setTimeout(() => {
                const id = '#' + item.id;
                const cant = parseInt(item.getAttribute('data-length'));
                let slidesPerViewDesktop = 3;
                let slidesPerViewMobile = 1.05;
                
                if(cant < 2){
                    slidesPerViewDesktop = 1;
                    slidesPerViewMobile = 1;
                }

                new Swiper(id, {
                    modules: [Navigation, Pagination],
                    loop: true,
                    navigation: {
                        nextEl: `.${item.getAttribute('data-arrow-right')}`,
                        prevEl: `.${item.getAttribute('data-arrow-left')}`
                    },
                    pagination: {
                        el: `.${item.getAttribute('data-pagination')}`,
                        clickable: true
                    },
                    slidesPerView: 1.7,
                    spaceBetween: 8,
                    breakpoints: {
                        280: {
                            slidesPerView: slidesPerViewMobile,
                            spaceBetween: 16,
                        },
                        768: {
                            spaceBetween: 16,
                            slidesPerView: slidesPerViewDesktop
                        }
                    },
                });
            }, 1200);
        });
    }
}

window.customElements.define('tabs-menu', TabsMenu);
window.customElements.define('tabs-content', TabsContent);